import Axios from "./interceptor";

const http = {
  get: async (url, data = {}) => Axios.get(url, { params: data }),
  post: async (url, data = {}) => Axios.post(url, data),
  downloadPost: async (url, data = {}, headers = {}) =>
    Axios.post(url, data, {
      responseType:'arraybuffer'
    }),
    postUpload: async (url, data = {}, headers = {}) =>
    Axios.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
};


export default http;
